import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "left" }}>
            Hi Everyone, I am <span className="purple">Kartik Mishra </span>
            from <span className="purple"> Shahdol, Madhya Pradesh, India.</span>
            <br />
            I am currently pursuing a B.Tech in CSE with a specialization in AI and ML at IES IPS Academy Indore. 
            I have completed my senior secondary education at Maharishi Vidya Mandir Shahdol.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Sketching
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing guitar
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">kartik</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
